module.exports = __webpack_public_path__ + "7b5481f8ef5b84bffb9f9e51ff884d60.pdf";